import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert } from '../../components/Alert';
import { AuthCard } from '../../components/AuthCard';
import { dossiers } from '../../lib/dossiers';
import { useSessionPortail } from './useSessionPortail';
import '../../styles/dossiers.css';

/**
 * Première connexion (11/10/2026) : créer son dossier tout de suite, ou aller
 * directement dans les applications (elles proposeront de le créer plus tard).
 * Quelle que soit la réponse, l'écran ne revient plus.
 */
export function BienvenuePage() {
  const navigate = useNavigate();
  const { pret } = useSessionPortail();
  const [erreur, setErreur] = useState<string | null>(null);
  const [envoi, setEnvoi] = useState(false);

  async function choisir(destination: string) {
    setEnvoi(true);
    setErreur(null);
    try {
      await dossiers.accueilVu();
      navigate(destination);
    } catch {
      setErreur('Impossible d’enregistrer votre choix. Réessayez dans un instant.');
      setEnvoi(false);
    }
  }

  if (!pret) return <AuthCard title="Chargement…">{null}</AuthCard>;

  return (
    <AuthCard title="Bienvenue sur SEmply" subtitle="Par quoi voulez-vous commencer ?">
      <Alert message={erreur} />
      <div className="dos-choix dos-choix--liste">
        <button type="button" className="product-card" disabled={envoi} onClick={() => void choisir('/dossiers/nouveau')}>
          <strong>Créer mon dossier</strong>
          <span>Votre entreprise, les applications à ouvrir et quelques questions pour tout paramétrer en une fois.</span>
        </button>
        <button type="button" className="product-card" disabled={envoi} onClick={() => void choisir('/produits')}>
          <strong>Accéder directement aux applications</strong>
          <span>Vous pourrez créer votre dossier plus tard, depuis l’application de votre choix.</span>
        </button>
      </div>
    </AuthCard>
  );
}
